// extracted by mini-css-extract-plugin
module.exports = {"progressButton":"SalesReportsBox_progressButton__lpUof","progressContent":"SalesReportsBox_progressContent__wH--b","spinner":"SalesReportsBox_spinner__1U0zy"};